// extracted by mini-css-extract-plugin
export default {"container":"select-payment-type_container__8BP+I","card":"select-payment-type_card__V11GG","cardLabel":"select-payment-type_cardLabel__6123g"};